import React, { useEffect, useState } from 'react'
import { DatePicker, Select, Table, Button, Space, message } from 'antd'
import dayjs from 'dayjs'
import axios from 'axios'
import {
  GetStudentListForMandirAttendance,
  GetStudentListForAttendance,
  StudentAttendanceNight,
  StudentAttendanceMorning,
  SaveStudentMandirAttendance,
} from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import '../Masters/MasterCSS.css'
import * as XLSX from 'xlsx'

const { Option } = Select

export default function StudentMandirAttendance() {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [date, setDate] = useState(dayjs()) // today's date
  const [studentList, setStudentList] = useState([])
  const [loading, setLoading] = useState(false)

   const [saveDisabled, setSaveDisabled] = useState(false);
    
    
      useEffect(() => {
      setSaveDisabled(false);
    }, [date]);
  

  // -----------------------------
  // Fetch attendance student list
  // -----------------------------
  const fetchStudents = async () => {
    setLoading(true)

    try {
      const res = await axios.get(
        `${GetStudentListForMandirAttendance}/${storedBranchId}/${BoardingYear}`,
      )

      const selectedDate = dayjs(date).format('YYYY-MM-DD')

      const formatted = res.data.map((item) => {
        let statusflag = '0'
        let disabledRow = false

        const todayAttendance = item.mandir_attendance?.find(
          (a) => a.attendance_date === selectedDate,
        )

        if (todayAttendance) {
          statusflag = todayAttendance.attendance_status?.toString() || '0'

          // Disable row if status is 1 or 2
          if (
            todayAttendance.attendance_status === 1 ||
            todayAttendance.attendance_status === 2
          ) {
            disabledRow = true
          }
        }

        return {
          reg_id: item.reg_id,
          full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
          room: item?.roombooking?.room?.room_no,
          bed: item?.roombooking?.bed?.bed_no,
          statusflag,
          disabledRow,
        }
      })

      setStudentList(formatted)
    } catch (err) {
      toast.error('Failed to load student list.')
    }

    setLoading(false)
  }

  useEffect(() => {
    if (date) fetchStudents()
  }, [date])

  // -----------------------------
  // Update individual attendance
  // -----------------------------
  const updateStatus = (id, flag) => {
    setStudentList((prev) =>
      prev.map((s) => (s.reg_id === id ? { ...s, statusflag: flag } : s)),
    )
  }

  // -----------------------------
  // Save Attendance
  // -----------------------------
  const handleSave = async () => {
    const pending = studentList.some((s) => s.statusflag === '0')
    if (pending) {
      toast.error('Please mark all students before saving.')
      return
    }

    const payload = {
      branch_id: parseInt(storedBranchId),
      year: BoardingYear,
      attendance_date: date.format('YYYY-MM-DD'),
      attendanceList: studentList.map((s) => ({
        reg_id: parseInt(s.reg_id),
        attendance_status: parseInt(s.statusflag),
      })),
    }

    try {
      const res = await axios.post(SaveStudentMandirAttendance, payload)

      if (res.data === 'MANDIRATTENDANCESAVED') {
        toast.success('Attendance saved successfully!')
      }
      setSaveDisabled(true);
    } catch (err) {
      console.error(err)
      toast.error('Failed to save attendance.')
    }
  }

  // -----------------------------
  // Table Columns
  // -----------------------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
      width: 70,
    },
    { title: 'Name', dataIndex: 'full_name' },
    { title: 'Room No', dataIndex: 'room', width: 100 },
    { title: 'Bed No', dataIndex: 'bed', width: 100 },

    {
      title: 'Attendance',
      dataIndex: 'statusflag',
      align: 'center',
      render: (flag, record) => (
        <Space>
          <Button
            primary
            type={flag === '1' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '1')}
          >
            P
          </Button>

          <Button
            danger
            type={flag === '2' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '2')}
          >
            A
          </Button>
        </Space>
      ),
    },
  ]

  const exportToExcel = () => {
    if (studentList.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = studentList.map((student, index) => ({
      'Sr No': index + 1,
      'Registration ID': student.reg_id,
      'Student Name': student.full_name,
      'Room No': student.room || '-',
      'Bed No': student.bed || '-',
      Date: date.format('DD-MM-YYYY'),
      Attendance:
        student.statusflag === '1'
          ? 'Present'
          : student.statusflag === '2'
          ? 'Absent'
          : 'Not Marked',
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 15 },
      { wch: 35 },
      { wch: 12 },
      { wch: 12 },
      { wch: 15 },
      { wch: 15 },
    ]

    const workbook = XLSX.utils.book_new()

    // Sheet name must be <= 31 characters
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Mandir Attendance')

    XLSX.writeFile(
      workbook,
      `Mandir_Attendance_${date.format('YYYY-MM-DD')}.xlsx`,
    )
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2 pb-3"></div>
        <div className="col-12 col-md-8 pb-3">
          <div className="header-row">
            <h2 className="page-title">Daily Mandir Attendance</h2>
          </div>

          {/* Filters */}
          <div
            className="d-flex justify-content-between align-items-center my-3 flex-wrap"
            style={{ gap: '15px' }}
          >
            <DatePicker
              value={date}
              format="DD-MM-YYYY"
              onChange={(d) => setDate(d)}
              disabledDate={(d) => d > dayjs()}
            />

            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
          </div>

          {/* Table */}
          <Table
            columns={columns}
            dataSource={studentList}
            rowKey="student_id"
            loading={loading}
            pagination={{ pageSize: 10 }}
            bordered
            rowClassName={(record) =>
              record.disabledRow ? 'locked-attendance-row' : ''
            }
            scroll={{ x: 'max-content' }}
            className="shadow border rounded"
          />

          <div className="text-center mt-3">
            <Button className="addButton" onClick={handleSave} disabled={saveDisabled}>
              Save Attendance
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-2 pb-3"></div>
      </div>
    </div>
  )
}
